import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/entreprise/Chauffeur-pour-entreprise.png";

const entreprise: ChauffeurPage = {
  slug: "entreprise",
  title: "Chauffeur entreprise – VTC corporate",
  subtitle: "Solutions récurrentes pour entreprises et équipes à Cannes.",
  keywords: ["chauffeur entreprise", "vtc corporate"],
  hero: {
    title: "Chauffeur pour entreprise",
    subtitle: "Déplacements d’équipes, clients et partenaires.",
    keywords: ["chauffeur corporate", "vtc business"],
    imageSrc: heroImage.src,
    imageAlt: "Chauffeur pour entreprise",
    badges: ["SLA & fiabilité", "Facturation claire", "Support dédié"],
  },
  benefits: {
    heading: "Atouts pour les pros",
    items: [
      {
        title: "SLA & fiabilité",
        description: "Engagements de service et reporting.",
      },
      {
        title: "Facturation claire",
        description: "Forfaits et conditions adaptés.",
      },
      {
        title: "Support dédié",
        description: "Réponse rapide par un interlocuteur unique.",
      },
    ],
  },
  services: {
    heading: "Services corporate",
    services: [
      {
        title: "Mise à disposition",
        text: "Chauffeurs pour comités & dirigeants à Cannes.",
      },
      {
        title: "Navettes équipes",
        text: "Déplacements réguliers et récurrents (Cannes, Sophia, Antibes).",
      },
    ],
  },
  locations: {
    heading: "Périmètres",
    items: [{ name: "Côte d’Azur" }, { name: "Provence" }],
  },
  generic: {
    heading: "Mobilité corporate simplifiée",
    subheading:
      "Un partenaire unique à Cannes pour vos déplacements récurrents.",
    paragraphs: [
      "Mise a disposition de chauffeurs dedies, reporting et pilotage des couts sur une base mensuelle ou evenementielle.",
      "Coordination fluide pour equipes, clients et dirigeants sur la Cote avec un cadre de service stable.",
      "Le dispositif corporate permet de standardiser la qualite de prise en charge sur l'ensemble de vos deplacements sensibles.",
    ],
    bullets: ["SLA & suivi", "Factures consolidées", "Support prioritaire"],
  },
  process: {
    heading: "Mise en place d'un compte entreprise",
    steps: [
      "Qualification de vos besoins recurrents et de vos priorites.",
      "Definition du cadre de service (SLA, horaires, perimetres).",
      "Activation des routines de reservation et de facturation.",
      "Suivi et ajustements selon vos usages réels.",
    ],
  },
  faq: [
    {
      q: "Peut-on centraliser la facturation de plusieurs collaborateurs ?",
      a: "Oui, nous proposons une gestion consolidée avec recapitulatif des courses et des postes de dépense.",
    },
    {
      q: "Est-il possible de définir des règles de service par profil ?",
      a: "Oui, nous pouvons adapter les conditions selon les equipes, les dirigeants ou les invites externes.",
    },
    {
      q: "Le service est-il compatible avec des demandes urgentes ?",
      a: "Oui, un support dédié permet de traiter rapidement les besoins urgents selon disponibilité.",
    },
  ],
  relatedLinks: [
    {
      label: "Devenir partenaire (conciergeries & hôtels)",
      href: "/chauffeur/partenaires",
    },
    {
      label: "Chauffeur pour événements entreprise",
      href: "/chauffeur/evenements",
    },
    {
      label: "Chauffeur Côte d’Azur, tarifs et trajets",
      href: "/chauffeur/cote-d-azur",
    },
    {
      // Sophia Antipolis est la 6e page la plus vue du site (895
      // impressions, position 15, zero clic) et le premier bassin
      // d'entreprises de la Cote d'Azur : le lien manquait ici, sur la
      // page meme des deplacements professionnels.
      label: "Chauffeur privé à Sophia Antipolis",
      href: "/chauffeur/sophia-antipolis",
    },
  ],
  cta: {
    title: "Ouvrir un compte entreprise",
    text: "Parlons de vos besoins récurrents et de vos contraintes.",
    primaryHref: "/contact",
    primaryLabel: "Contact commercial",
  },
  seo: {
    title: "Chauffeur entreprise – VTC corporate & récurrent",
    description:
      "Solutions VTC pour entreprises à Cannes: comptes, navettes équipes, dirigeants.",
    canonical: "/chauffeur/entreprise",
  },
};

export default entreprise;
